import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import { rhythm } from "../utils/typography"
import Image from "gatsby-image"

const Bio = () => {
  const data = useStaticQuery(graphql`
    query BioQuery {
      avatar: file(absolutePath: { regex: "/index-pic.png/" }) {
        childImageSharp {
          fixed(width: 100, height: 100) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      site {
        siteMetadata {
          author {
            name
            summary
          }
          social {
            twitter
            github
          }
        }
      }
    }
  `)

  const { author } = data.site.siteMetadata
  return (
    <div
      style={{
        display: `block`,
        marginBottom: rhythm(2.5),
        fontFamily: `Montserrat, sans-serif`,
        listStyle: "none",
      }}
    >
      <ul style={{ listStyleType: `none`, marginLeft: 0, textAlign: "start" }}>
        <li style={{ display: `inline`, marginRight: 15 }}>
          <Link
            style={{
              color: "#5F5F5F",
              fontSize: "16px",
              fontWeight: "bold",
              fontFamily: `Montserrat, sans-serif`,
            }}
            to={`/`}
          >
            Home
          </Link>
        </li>
        <li style={{ display: `inline`, marginRight: 0 }}>
          <Link
            style={{
              color: "#5F5F5F",
              fontSize: "16px",
              fontFamily: `Montserrat, sans-serif`,
              fontWeight: "bold",
            }}
            to={`/posts`}
          >
            Blog
          </Link>
        </li>
      </ul>
      <div style={{ marginTop: 15, marginBottom: 15, textAlign: `center` }}>
        <Image
          fixed={data.avatar.childImageSharp.fixed}
          alt={author.name}
          style={{
            marginRight: rhythm(1 / 2),
            marginBottom: 0,
            minWidth: 100,
            borderRadius: `100%`,
          }}
          imgStyle={{
            borderRadius: `50%`,
          }}
        />
      </div>
      <div style={{ textAlign: `justify`, textJustify: `inter-word` }}>
        <p>
          I'm a Software Engineer from Chennai, India. I did my engineering in
          Electronics & Communications from{" "}
          <a
            target="_blank"
            rel="noreferrer"
            style={{ boxShadow: `none`, color: `#830008` }}
            href="http://www.psvpec.in/"
          >
            Prince Shri Venkateshwara Padmavathy Engineering College
          </a>{" "}
          under the affiliation of{" "}
          <a
            target="_blank"
            rel="noreferrer"
            style={{ boxShadow: `none`, color: `#006BA5` }}
            href="https://www.annauniv.edu/"
          >
            Anna University
          </a>{" "}
          and graduated in May 2012 .
        </p>
        <p>
          In the January of 2013, I joined my first job as a Software Engineer
          at{" "}
          <a
            target="_blank"
            rel="noreferrer"
            style={{ boxShadow: `none`, color: `#10337D` }}
            href="https://www.sundaraminfotech.in/"
          >
            Sundaram Infotech
          </a>{" "}
          on HOMFINSYS team . I was a part of the team that was responsible for
          migrating the legacy product from Oracle Forms technology into Oracle
          ADF. In the October of 2016, I left my position at Sundaram Infotech
          to join{" "}
          <a
            target="_blank"
            rel="noreferrer"
            style={{ boxShadow: `none`, color: `#C74634` }}
            href="https://oracle.com"
          >
            Oracle
          </a>
          .
        </p>
        <p>
          I worked as an Applications Developer in the OFSLL team that provides
          solutions to Lending & Leasing customers across the globe. It is a fun
          team where I get to build a product that brings a lot of value to our
          customers and learn from the best minds in the industry. I left Oracle
          in the month of October 2020 to join{" "}
          <a
            target="_blank"
            rel="noreferrer"
            style={{ boxShadow: `none`, color: `#000000` }}
            href="https://ust.com/en"
          >
            UST
          </a> as System Analyst
          .
        </p>
        <p>
          I’m a self-learner with an acute eye on the current events in the
          industry. I'm learning how to build distributed systems on a large
          scale and on the various factor to be considered. I also write
          articles on{" "}
          <a
            target="_blank"
            rel="noreferrer"
            style={{ color: `#292929` }}
            href="https://medium.com/@vivekts90"
          >
            Medium
          </a>
          {`   `}and{`   `}
          <a
            target="_blank"
            rel="noreferrer"
            style={{ color: `#08090A` }}
            href="https://dev.to/vivekworks"
          >
            DEV
          </a>
          .
        </p>
      </div>
    </div>
  )
}

export default Bio
